module.exports = __webpack_public_path__ + "static/media/bt_top_daytraining_over.b7e450df.png";